(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/announcements/assets/javascripts/trinidad-announcements.js') >= 0) return;  svs.modules.push('/components/core/announcements/assets/javascripts/trinidad-announcements.js');

'use strict';

svs = svs || {};
svs.core = svs.core || {};
svs.core.trinidadAnnouncements = svs.core.trinidadAnnouncements || {};
svs.core.trinidadAnnouncements.data = svs.core.trinidadAnnouncements.data || {};
const tribe = svs.core.config.data.svsconfig.tribe;
let _activeTribe = tribe; 
const announcementsLogger = function getLogger() {
  try {
    if (svs && svs.core && svs.core.log && svs.core.log.Logger) {
      return new svs.core.log.Logger('component:core.announcements');
    }
  } catch (e) {
  }
  return null;
}();

function logError() {
  try {
    if (announcementsLogger && announcementsLogger.error) {
      announcementsLogger.error.apply(announcementsLogger, arguments);
    }
  } catch (e) {
  }
}
const EVENT_NAME = 'trinidad:announcement-update';
const resolvePath = () => "/_trinidad/".concat(_activeTribe, "/announcements/resolve");
const debounceMs = 75;
let controller = null;
let initialized = false;
let debTimer = null;

let suppressNextPopstate = false;
let initialBackForward = false;
let initialBackForwardEmitSuppressed = false;
const etagByUrl = new Map();
const payloadByUrl = new Map();
const unifiedByUrl = new Map();
const emittedForUrl = new Map();
const seenUnifiedIds = new Set();
const lastEmittedSigByUrl = new Map();
const lastEmittedSigByUnified = new Map();
const emittedOnceDisableOnSSR = new Map();
const ssrEmittedUrl = new Set();
const ssrInitialSigByUrl = new Map();
const nowUrl = () => "".concat(location.pathname).concat(location.search);
const getOptions = () => {
  const d = svs && svs.core && svs.core.trinidadAnnouncements && svs.core.trinidadAnnouncements.data || {};
  let showPolicy = typeof d.showPolicy === 'string' ? d.showPolicy : 'always';
  if (!/^(always|once-per-route|once-per-session)$/.test(showPolicy)) {
    showPolicy = 'always'; 
  }
  let frequencyWindowMs = Number(d.frequencyWindowMs);
  if (!Number.isFinite(frequencyWindowMs) || frequencyWindowMs < 0) {
    frequencyWindowMs = 0;
  }
  return {
    disableOnSSR: d.disableOnSSR === true,
    showPolicy,
    frequencyWindowMs
  };
};

const MAX_CACHE_ENTRIES = 150; 
const pruneMap = m => {
  try {
    if (!m || m.size <= MAX_CACHE_ENTRIES) {
      return;
    }
    let toRemove = m.size - MAX_CACHE_ENTRIES;
    for (const k of m.keys()) {
      m.delete(k);
      toRemove -= 1;
      if (toRemove <= 0) {
        break;
      }
    }
  } catch (e) {
  }
};

const computePayloadSignature = detail => {
  try {
    const unified = detail && detail.unifiedRouteId || '';
    const anns = Array.isArray(detail && detail.announcements) ? detail.announcements : [];
    const parts = anns.map(a => {
      if (!a || typeof a !== 'object') {
        return String(a);
      }
      const title = a.title || '';
      const msg = a.message || a.body || '';
      const type = a.type || '';
      const firstBtn = Array.isArray(a.buttons) && a.buttons.length ? a.buttons[0].text || '' : '';
      const msgSig = msg ? "".concat(msg.length, ":").concat(msg.slice(0, 40)) : '';
      return "".concat(title, "|").concat(type, "|").concat(firstBtn, "|").concat(msgSig);
    });
    return "".concat(unified, "#").concat(parts.join(','));
  } catch (e) {
    return 'sig:error';
  }
};

const normalizeAnnouncements = detail => {
  try {
    if (!detail || !Array.isArray(detail.announcements)) {
      return detail;
    }
    detail.announcements = detail.announcements.map(a => {
      if (!a || typeof a !== 'object') {
        return a;
      }
      const title = a.title || '';
      const body = a.body || a.message || '';
      const buttons = Array.isArray(a.buttons) && a.buttons.length ? a.buttons.map(b => ({
        text: b && b.text ? b.text : ''
      })) : [{
        text: 'Okej'
      }];
      return {
        title,
        message: body,
        buttons,
        type: a.type || 'error'
      };
    });
  } catch (e) {
  }
  return detail;
};
const emit = detail => {
  try {
    if (typeof document === 'undefined') {
      return;
    }
    let ev;
    try {
      ev = new CustomEvent(EVENT_NAME, {
        detail
      });
    } catch (e2) {
      try {
        ev = document.createEvent('CustomEvent');
        ev.initCustomEvent(EVENT_NAME, false, false, detail);
      } catch (e3) {
        return; 
      }
    }
    document.dispatchEvent(ev);
  } catch (e) {
  }
};

const isCancelledFetch = e => {
  if (!e) {
    return false;
  }
  if (e.name === 'AbortError') {
    return true;
  }
  if (e.name === 'TypeError' && (e.message === 'Load failed' || e.message === 'NetworkError when attempting to fetch resource.')) {
    return true;
  }
  return false;
};
const fetchResolve = async (urlStr, skipEtag) => {
  const originalTribe = _activeTribe;
  async function singleAttempt(currentSkipEtag) {
    if (controller) {
      try {
        controller.abort();
      } catch (e) {
      }
    }
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    let timeoutId = null;
    if (controller) {
      timeoutId = setTimeout(() => {
        controller.abort();
      }, 15000);
    }
    const qs = new URLSearchParams({
      url: urlStr
    });
    if (currentSkipEtag) {
      qs.set('_', String(Date.now()));
    }
    const headers = {
      Accept: 'application/json',
      'Cache-Control': 'no-store'
    };
    const etag = etagByUrl.get(urlStr);
    if (etag && !currentSkipEtag) {
      headers['If-None-Match'] = etag;
    }
    const opts = {
      method: 'GET',
      headers,
      cache: 'no-store',
      keepalive: false,
      mode: 'cors',
      credentials: 'same-origin'
    };
    if (controller) {
      opts.signal = controller.signal;
    }
    if (typeof fetch !== 'function') {
      throw new Error('fetch API not available');
    }
    let res;
    try {
      res = await fetch("".concat(resolvePath(), "?").concat(qs.toString()), opts);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    } catch (e) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (!isCancelledFetch(e)) {
        const errorDetails = {
          message: e && e.message,
          name: e && e.name,
          code: e && e.code,
          stack: e && e.stack,
          url: "".concat(resolvePath(), "?").concat(qs.toString()),
          userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown'
        };
        logError('[fetch] network error', errorDetails);
      }
      throw e;
    }
    return res;
  }

  let res;
  let lastError;
  const maxRetries = 2;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      res = await singleAttempt(skipEtag);
      break; 
    } catch (e) {
      lastError = e;

      if (isCancelledFetch(e)) {
        throw e; 
      }
      if (attempt < maxRetries) {
        const waitMs = 2 ** attempt * 1000;
        await new Promise(resolve => {
          setTimeout(resolve, waitMs);
        });
        logError("[fetch] retry ".concat(attempt + 1, "/").concat(maxRetries, " after ").concat(waitMs, "ms"));
      }
    }
  }
  if (!res) {
    throw lastError;
  }
  if (res.status === 404) {
    let body404;
    try {
      body404 = await res.clone().json();
    } catch (e) {
      body404 = null;
    }
    if (body404 && body404.error === 'tribe_mismatch' && body404.expected) {
      const newTribe = body404.expected;
      if (newTribe && newTribe !== _activeTribe) {
        _activeTribe = newTribe;
        etagByUrl.delete(urlStr);
        try {
          res = await singleAttempt(true); 
        } catch (retryErr) {
          _activeTribe = originalTribe;
          throw retryErr;
        }
      }
    } else {
      logError('[fetch] HTTP 404', body404 && body404.error ? body404.error : 'not_found');
      throw new Error('HTTP 404');
    }
  }
  const resEtag = res.headers.get && res.headers.get('ETag');
  if (resEtag) {
    etagByUrl.set(urlStr, resEtag);
  }
  if (res.status === 304) {
    return {
      notModified: true
    };
  }
  if (!res.ok) {
    logError('[fetch] HTTP error', res.status);
    throw new Error("HTTP ".concat(res.status));
  }
  return res.json();
};
const shouldEmit = (detail, urlKey, navKind) => {
  const opts = getOptions();
  const {
    showPolicy,
    disableOnSSR
  } = opts;
  const unified = detail && detail.unifiedRouteId || null;
  const currentSig = computePayloadSignature(detail);

  if (disableOnSSR) {
    const initSig = ssrInitialSigByUrl.get(urlKey);
    if (initSig && initSig === currentSig) {
      ssrInitialSigByUrl.delete(urlKey); 
      return false;
    }
  }

  if (disableOnSSR && navKind === 'popstate' && initialBackForward && !initialBackForwardEmitSuppressed) {
    try {
      lastEmittedSigByUrl.set(urlKey, currentSig);
      if (unified) {
        lastEmittedSigByUnified.set(unified, currentSig);
      }
    } catch (e) {
    }
    initialBackForwardEmitSuppressed = true;
    return false;
  }

  if (disableOnSSR && navKind === 'popstate') {
    if (unified) {
      const prevUnifiedSig = lastEmittedSigByUnified.get(unified);
      return !prevUnifiedSig || prevUnifiedSig !== currentSig;
    }
    const prevUrlSig = lastEmittedSigByUrl.get(urlKey);
    return !prevUrlSig || prevUrlSig !== currentSig;
  }

  if (unified) {
    const prevUnifiedSig = lastEmittedSigByUnified.get(unified);
    if (prevUnifiedSig && prevUnifiedSig !== currentSig) {
      return true;
    }
  } else {
    const prevUrlSig = lastEmittedSigByUrl.get(urlKey);
    if (prevUrlSig && prevUrlSig !== currentSig) {
      return true;
    }
  }
  if (showPolicy === 'always') {
    return true;
  }
  if (showPolicy === 'once-per-session') {
    if (unified) {
      return !seenUnifiedIds.has(unified);
    }
    return emittedForUrl.get(urlKey) !== true;
  }
  if (showPolicy === 'once-per-route') {
    if (emittedForUrl.get(urlKey) !== true) {
      return true;
    }
    return unified !== unifiedByUrl.get(urlKey);
  }

  return false;
};
const handleResult = (detail, urlKey, navKind) => {
  if (!detail) {
    return;
  }
  normalizeAnnouncements(detail);
  payloadByUrl.set(urlKey, detail);
  pruneMap(payloadByUrl);
  const items = detail && detail.announcements || [];
  const optsTmp = getOptions();
  let preSig;
  try {
    preSig = computePayloadSignature(detail);
  } catch (e) {
  }
  const {
    showPolicy: spLocal,
    disableOnSSR: disLocal
  } = optsTmp;
  if (spLocal !== 'always' && disLocal && emittedOnceDisableOnSSR.get(urlKey) && preSig && preSig === lastEmittedSigByUrl.get(urlKey)) {
    return; 
  }
  if (shouldEmit(detail, urlKey, navKind)) {
    const {
      showPolicy
    } = getOptions();
    const unified = detail && detail.unifiedRouteId || null;
    if (showPolicy === 'once-per-route') {
      emittedForUrl.set(urlKey, true);
      unifiedByUrl.set(urlKey, unified);
      pruneMap(emittedForUrl);
      pruneMap(unifiedByUrl);
    }
    if (unified && showPolicy === 'once-per-session') {
      try {
        seenUnifiedIds.add(unified);
      } catch (e) {
      }
    }
    const sig = preSig || computePayloadSignature(detail);
    try {
      lastEmittedSigByUrl.set(urlKey, sig);
      pruneMap(lastEmittedSigByUrl);
      if (unified) {
        lastEmittedSigByUnified.set(unified, sig);
        pruneMap(lastEmittedSigByUnified);
      }
    } catch (e) {
    }
    if (optsTmp.disableOnSSR) {
      emittedOnceDisableOnSSR.set(urlKey, true);
    }
    if (items.length === 0) {
      emit(detail);
      return;
    }
    emit(detail);
  }
};
const onUrlChange = navKind => {
  const opts = getOptions();
  const disableOnSSR = opts.disableOnSSR === true;
  const kind = navKind || 'soft';
  if (!disableOnSSR) {
    try {
      emit({
        announcements: []
      });
    } catch (e) {
    }
  }
  if (debTimer) {
    clearTimeout(debTimer);
  }
  debTimer = setTimeout(async () => {
    const urlKey = nowUrl();
    try {
      const result = await fetchResolve(urlKey, false);
      if (result && result.notModified) {
        const cached = payloadByUrl.get(urlKey);
        if (cached) {
          handleResult(cached, urlKey, kind);
          return;
        }
        let fresh;
        try {
          fresh = await fetchResolve(urlKey, true);
        } catch (e2) {
          return; 
        }
        handleResult(fresh, urlKey, kind);
        return;
      }
      handleResult(result, urlKey, kind);
    } catch (e) {
      if (!isCancelledFetch(e)) {
        logError('[fetch] resolve failed', e && e.message);
      }

      if (isCancelledFetch(e)) {
        return;
      }

      if (disableOnSSR) {
        const urlKeyFallback = nowUrl();
        if (!emittedOnceDisableOnSSR.get(urlKeyFallback) && !lastEmittedSigByUrl.get(urlKeyFallback)) {
          try {
            emit({
              announcements: []
            });
            emittedOnceDisableOnSSR.set(urlKeyFallback, true);
            lastEmittedSigByUrl.set(urlKeyFallback, 'fallback-empty');
          } catch (e2) {
          }
        }
      }
    }
  }, debounceMs);
};
const patchHistory = () => {
  try {
    if (typeof window === 'undefined' || typeof history === 'undefined') {
      return;
    }
    const origPush = history.pushState;
    const origReplace = history.replaceState;
    if (origPush && !origPush.__TRINIDAD_ANN_PATCHED__) {
      history.pushState = function pushStatePatched() {
        const ret = origPush.apply(this, arguments); 
        try {
          onUrlChange('push');
        } catch (e) {
        }
        return ret;
      };
      history.pushState.__TRINIDAD_ANN_PATCHED__ = true;
    }
    if (origReplace && !origReplace.__TRINIDAD_ANN_PATCHED__) {
      history.replaceState = function replaceStatePatched() {
        const ret = origReplace.apply(this, arguments); 
        try {
          onUrlChange('replace');
        } catch (e) {
        }
        return ret;
      };
      history.replaceState.__TRINIDAD_ANN_PATCHED__ = true;
    }
    if (!window.__TRINIDAD_ANN_POPSTATE_BOUND__) {
      window.addEventListener('popstate', () => {
        try {
          if (suppressNextPopstate) {
            suppressNextPopstate = false;
            return;
          }
          onUrlChange('popstate');
        } catch (e) {}
      });
      window.__TRINIDAD_ANN_POPSTATE_BOUND__ = true;
    }
  } catch (e) {
  }
};
const consumeSSR = opts => {
  const emitEvent = !opts || opts.emit !== false;
  try {
    if (typeof window === 'undefined' || !window.__TRINIDAD_ANNOUNCEMENT__) {
      return false;
    }
    const payload = window.__TRINIDAD_ANNOUNCEMENT__;
    delete window.__TRINIDAD_ANNOUNCEMENT__;
    const urlKey = nowUrl();
    normalizeAnnouncements(payload);
    payloadByUrl.set(urlKey, payload);
    const {
      showPolicy
    } = getOptions();
    const unified = payload && payload.unifiedRouteId || null;

    if (showPolicy === 'once-per-route') {
      unifiedByUrl.set(urlKey, unified);
      emittedForUrl.set(urlKey, true);
      pruneMap(unifiedByUrl);
      pruneMap(emittedForUrl);
    }

    if (unified && showPolicy === 'once-per-session') {
      try {
        seenUnifiedIds.add(unified);
      } catch (e) {
      }
    }

    try {
      const sig = computePayloadSignature(payload);
      lastEmittedSigByUrl.set(urlKey, sig);
      pruneMap(lastEmittedSigByUrl);
      if (unified) {
        lastEmittedSigByUnified.set(unified, sig);
        pruneMap(lastEmittedSigByUnified);
      }
    } catch (e) {
    }

    if (emitEvent) {
      emit(payload);
    }
    if (emitEvent) {
      try {
        ssrEmittedUrl.add(urlKey);
        const sig = lastEmittedSigByUrl.get(urlKey);
        if (sig) {
          ssrInitialSigByUrl.set(urlKey, sig);
        }
      } catch (e) {}
    } else {
      try {
        const sig = lastEmittedSigByUrl.get(urlKey);
        if (sig) {
          ssrInitialSigByUrl.set(urlKey, sig);
        }
      } catch (e) {}
    }
    return true;
  } catch (e) {
  }
  return false;
};
const forceCheck = () => {
  onUrlChange();
};
const init = () => {
  let nav; 
  try {
    const {
      disableOnSSR
    } = getOptions();
    try {
      const navEntries = typeof performance !== 'undefined' && performance.getEntriesByType ? performance.getEntriesByType('navigation') : null;
      nav = navEntries && navEntries[0];
    } catch (e) {
    }

    if (disableOnSSR) {
      const isHard = Boolean(nav && (nav.type === 'navigate' || nav.type === 'reload'));
      if (isHard) {
        if (!initialized) {
          initialized = true;
          patchHistory();
        }
        consumeSSR({
          emit: false
        });
        return;
      }
    }
  } catch (e) {
  }
  if (initialized) {
    return;
  }
  initialized = true;
  let initialNavKind = 'init';
  try {
    if (!nav) {
      let navEntries;
      try {
        navEntries = typeof performance !== 'undefined' && performance.getEntriesByType ? performance.getEntriesByType('navigation') : null;
      } catch (e) {
      }
      nav = navEntries && navEntries[0];
    }
    if (nav && nav.type === 'back_forward') {
      initialNavKind = 'popstate';
      suppressNextPopstate = true;
      initialBackForward = true; 
    }
  } catch (e) {
  }
  patchHistory();
  if (!consumeSSR()) {
    onUrlChange(initialNavKind);
  }
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
}
svs.core.trinidadAnnouncements = {
  init,
  forceCheck,
  version: '0.7.3',
  data: svs.core.trinidadAnnouncements.data
};

try {
  if (svs.core.trinidadAnnouncements.data && svs.core.trinidadAnnouncements.data.enableTestHelpers) {
    svs.core.trinidadAnnouncements._test = {
      _resetState() {
        try {
          initialized = false; 
          controller = null;
          suppressNextPopstate = false;
          initialBackForward = false;
          initialBackForwardEmitSuppressed = false;
          etagByUrl.clear();
          payloadByUrl.clear();
          unifiedByUrl.clear();
          emittedForUrl.clear();
          seenUnifiedIds.clear();
          lastEmittedSigByUrl.clear();
          lastEmittedSigByUnified.clear();
          emittedOnceDisableOnSSR.clear();
          ssrEmittedUrl.clear();
          ssrInitialSigByUrl.clear();
        } catch (e) {}
      }
    };
  }
} catch (e) {}

 })(window);